export const strings = {
    clients: {
        otherNotesLabel: "Additional Notes Regarding Needs / Desires",
    },
};
